import Vue from 'vue'
import Vuex from 'vuex'
import uploadSummaryStore from '@/components/upload-data/store'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    ...uploadSummaryStore,
    drawerOpen: false,
    back: '/home',
    db: null,
    showAppbar: false,
    navbarText: '',
    loading: false,
    loadingMessage: '',
    selectedFarmId: 0,
    online: false,
    openSyncs: 0,
    userDeniedSync: false,
    syncErrors: [],
    token: null,
    user: null,
    account: null,
    redirectToFromGuard: '/home',
    colors: [  // keep in sync with vuetify.ts colors     
      '#c19d43',
      '#be6043',
      '#658b6f',
      '#99aead',
      '#28363d',
      '#dee1dd',
    ],
    snackbars: [],
    filters: {
      pregnantOverdue: false
    },
  },
  mutations: {
  },
})
